<template>
  <div class="kpi_table--column--cell">
    <p class="kpi_table--column--cell--amount">{{ goal }}</p>

    <icon-default
      class="kpi_table--column--cell--icon"
      icon="edit"
      size="is-small"
      @click="openModal"
    />

    <modal-container>
      <modal-default
        ref="goalModal"
        title="Set Goals"
      >
        <h3 class="subtitle">{{ row.label }}</h3>

        <grid-row>
          <grid-column>
            <form-field-input
              label="Weekly Goal"
              v-model="weeklyGoal"
              type="number"
            ></form-field-input>
          </grid-column>

          <grid-column>
            <form-field-input
              label="Monthly Goal"
              v-model="monthlyGoal"
              type="number"
            ></form-field-input>
          </grid-column>
        </grid-row>

        <p class="hint_text"><span>HINT:</span> if you don't want a goal set this to 0</p>

        <template v-slot:footer>
          <button-outlined
            :loading="isSaving"
            :disabled="isSaving"
            @click="save"
          >Update Goals
          </button-outlined>
        </template>
      </modal-default>
    </modal-container>
  </div>
</template>

<script>
import api from "../../../api";

export default {
  name: "StatsKpiCellGoal",
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isSaving: false,
      newWeeklyGoal: null,
      newMonthlyGoal: null,
    }
  },
  computed: {
    goals() {
      return this.$store.getters["statsKpi/goals"]
    },
    goal() {
      const amount = this.goals[this.id];

      if (!amount) return '-';
      return Math.round(amount);
    },
    row() {
      return this.$store.getters["statsKpi/kpiRowInfo"][this.id];
    },
    weeklyGoal: {
      get() {
        const goal = this.$store.state.statsKpi.weeklyGoals[this.id]
        if (!goal) return 0;
        return goal
      },
      set(newValue) {
        // don't update store until the values are saved in api
        this.newWeeklyGoal = newValue
      }
    },
    monthlyGoal: {
      get() {
        const goal = this.$store.state.statsKpi.monthlyGoals[this.id]
        if (!goal) return 0;
        return goal
      },
      set(newValue) {
        // don't update store until the values are saved in api
        this.newMonthlyGoal = newValue
      }
    },
  },
  methods: {
    openModal() {
      this.$refs.goalModal.open()
    },
    save() {
      let data = {
        marketId: this.$store.getters.market.id
      }

      // Make sure you send a number to the api and not a string
      data[this.row.goalPrefix + '_weekly_goal'] = parseInt(this.newWeeklyGoal);
      data[this.row.goalPrefix + '_monthly_goal'] = parseInt(this.newMonthlyGoal);

      this.isSaving = true;

      api.markets.patchGoals(data).then(response => {
        // update store goals
        this.$store.commit('statsKpi/setGoals', response.data)

        this.$buefy.toast.open({
          message: 'Your goals have been updated',
          type: 'is-success'
        });

        this.$refs.goalModal.close()
      }).finally(() => {
        this.isSaving = false;
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.kpi_table--column--cell {

  &--amount {
    margin: 0 10px;
  }

  &--icon {
    color: $text-light;
    cursor: pointer;

    &:hover {
      color: $link-hover;
    }
  }
}
</style>
